<template>
    <div class="content">
        <p
            v-if="(!slotData.id)"
            class="content-text-info"
        >
            {{ $t("App.RightSlot.SelectArea") }}
        </p>
        <dynamic-table :table-data="slotData.tableData" />
        <star-rating
            v-if="slotData.starRating > 0.0"
            class="star-rating"
            :rating-value="slotData.starRating"
            :label="starRatingLabel"
        />
        <!-- eslint-disable vue/no-v-html -->
        <p
            v-if="(slotData.textContent != null)"
            class="content-text-info"
            v-html="slotData.textContent"
        />
        <!--eslint-enable-->
        <a
            v-if="slotData.textContent"
            class="open-modal-link open-modal-mobiiliverkko"
            tabindex="0"
            @click="openModal"
            @keydown.enter="openModal"
        >{{ $t("App.LaajakaistaJaPuhelin.Lisatiedotkunnanmobiililiittymista") }}</a>
        <p class="content-text-info">
            {{ infotext }}
        </p>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Watch } from "vue-facing-decorator"
    import DynamicTable from "@/components/DynamicTable.vue"
    import DynamicRightSlotData from "../../../../models/dynamicrighslotdata"
    import StarRating from "@/components/StarRating.vue"
    import ApiService from "@/services/ApiService"
    import { store } from '@/store/store'

    @Component({
        components: {
            "dynamic-table": DynamicTable,
            "star-rating": StarRating
        }
    })
    export default class MobiiliverkonKattavuus extends Vue {
        apiService: ApiService = new ApiService(store.getters.baseHref)
        apiCallBasePart: string = "v1/Viestinta/LaajakaistaJaPuhelin/"

        openModal() {
            try {
                const header = (this.$t("App.LaajakaistaJaPuhelin.Lisatiedotkunnanmobiililiittymista") ?? "")
                store.dispatch("setHeader", header)

                const selectedAreaRadioButton = this.getSelectedAreaRadioButton()

                // varmistetaan että on kunnat valittuna näkyville
                if (selectedAreaRadioButton !== "kunta") {
                    return
                }

                // modalin muodostaminen servicessä
                store.dispatch("setDataUrlToLoad", { url: this.apiCallBasePart + "MobiiliverkonHintatiedot", type: "MobiiliverkonKattavuusModal" })
            }
            catch (err) {
                console.log(err)
                throw new Error(this.apiService.generateErrorMsg(err))
            }
        }

        getSelectedMunicipality(): string {
            return this.slotData?.id ?? ""
        }

        getSelectedProvince(): string {
            return this.slotData?.id ?? ""
        }

        getSelectedAreaRadioButton(): string {
            return store.getters.selectedAreaRadioButton
        }

        get slotData(): DynamicRightSlotData | null {
            return (store.getters.rightSlotData as DynamicRightSlotData)
        }

        get starRatingLabel(): string | undefined {
            const selectedAreaRadioButton = this.getSelectedAreaRadioButton()
            if (selectedAreaRadioButton === "kunta") {
                return this.$t("App.StarRating.LabelMVkunta")
            }
            else if (selectedAreaRadioButton === "maakunta") {
                return this.$t("App.StarRating.LabelMVMaakunta")
            }
            return this.$t("App.StarRating.LabelMVKokoSuomi")
        }

        get modalValue(): string {
            return store.getters.modalComponentName
        }

        @Watch("modalValue")
        handleModalCloses(newVal, oldVal) {
            if (oldVal === "LisatiedotKunnanMobiililiittymistaModal" && newVal === "") {
                (this.$el.querySelectorAll(".open-modal-mobiiliverkko")[0] as HTMLTableRowElement).focus()
            }
        }

        get infotext(): string | undefined {
            return this.$t("App.LaajakaistaJaPuhelin.MVSaatavuus.InfoText")
        }
    }
</script>

<style>
    img.external-icon {
        width: 18px;
        margin-left: 5px;
    }
</style>
